import { useCompany } from '@/lib/CompanyProvider'

export function useTenantFeature(featureKey: string) {
  const { activeCompanyId, companies, isLoading } = useCompany()
  
  const company = companies.find(c => c.id === activeCompanyId)

  // Verifica se o JSONB `custom_features` possui a chave com valor verdadeiro
  const customFeatures = (company as any)?.custom_features as Record<string, boolean> | undefined
  const hasAccess = Boolean(customFeatures?.[featureKey])

  return { hasAccess, isLoading, company }
}
